import { api } from "./api";

import {
  ChannelPresenceResponse,
  PresenceResponse,
  RTMTokenResponse,
} from "@customTypes/rtm";


export const getTeleconsultationRTMToken = async (
  consultationId: string
): Promise<RTMTokenResponse> => {
  const response = await api.get<RTMTokenResponse>(
    `teleconsultation/${consultationId}/rtm-token`
  );

  return response.data;
};

export const joinPresence = async ({
  channelId,
  userId,
  metadata,
}: {
  channelId: string;
  userId: string;
  metadata?: Record<string, unknown>;
}): Promise<PresenceResponse> => {
  const response = await api.post<PresenceResponse>("rtm/presence/join", {
    channel_id: channelId,
    user_id: userId,
    metadata: metadata ?? {},
  });

  return response.data;
};

export const leavePresence = async ({
  channelId,
  userId,
}: {
  channelId: string;
  userId: string;
}): Promise<PresenceResponse> => {
  const response = await api.post<PresenceResponse>("rtm/presence/leave", {
    channel_id: channelId,
    user_id: userId,
  });

  return response.data;
};

export const sendPresenceHeartbeat = async ({
  channelId,
  userId,
}: {
  channelId: string;
  userId: string;
}): Promise<PresenceResponse> => {
  const response = await api.post<PresenceResponse>("rtm/presence/heartbeat", {
    channel_id: channelId,
    user_id: userId,
  });

  return response.data;
};

export const getChannelPresence = async (
  channelId: string
): Promise<ChannelPresenceResponse> => {
  const response = await api.get<ChannelPresenceResponse>(
    `rtm/presence/channel/${channelId}`
  );

  return response.data;
};
